import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import styles from './ProductCard.module.css';

export default function ProductCard({ product, brandSlug, accentColor }) {
  return (
    <div className={styles.card}>
      {/* Product Image */}
      <div className={styles.imageWrap}>
        <img src={product.image} alt={product.name} className={styles.image} />
        <div className={styles.imageOverlay} style={{ background: accentColor }} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        <h3 className={styles.name}>{product.name}</h3>
        <p className={styles.brief}>{product.brief}</p>

        {/* Features */}
        <ul className={styles.features}>
          {product.features.map((f, i) => (
            <li key={i} className={styles.feature}>
              <CheckCircle size={14} style={{ color: accentColor || 'var(--navy)', flexShrink: 0 }} />
              <span>{f}</span>
            </li>
          ))}
        </ul>

        <Link
          to={`/brands/${brandSlug}/${product.slug}`}
          className={styles.btn}
          style={{ '--btn-color': accentColor || 'var(--navy)' }}
        >
          View Models <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
